import {EntityService} from '../../../service/EntityService';

export class EntityAuditLogService extends EntityService {

  static entity = 'vinca-system/operation-logs';
  static getListData(lazyLoadEvent: string, params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/?lazyLoadEvent=${lazyLoadEvent}`, {params}).then(res => res.data);
  }
}